/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */

import React from 'react';

const DropdownInlineMenu = ({ selections }) => (
  <div data-bem="DropdownInlineMenu" className="inline-menu">
    {selections.map((selection) => (
      <div className="inline-menu-item" key={selection.text.replace(' ', '')} id={selection.text} tabIndex={0} role="button" onClick={selection.callback}>
        {selection.icon && <img src={selection.icon} alt={selection.text} className="icon" />}
        <div>{selection.text}</div>
      </div>
    ))}
  </div>
);

export default DropdownInlineMenu;
